import React from 'react';
import Header from './Header';
import SEO from './SEO';

const PrivacyPolicy = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <SEO 
        title="Privacy Policy - PocketHints"
        description="Privacy Policy for PocketHints Helper."
        url={(typeof window !== 'undefined' ? window.location.origin : '') + '/privacy-policy'}
      />
      
      <Header 
        date={new Date().toISOString()} 
        title="Privacy Policy" 
        heroTitle="Privacy Policy"
        introText="How we handle and protect your personal information at PocketHints."
      />

      <main className="flex-grow max-w-4xl mx-auto px-4 w-full pb-20">
        <h1 className="text-3xl font-bold mb-6 text-brand-black">Privacy Policy</h1>
        
        <div className="prose max-w-none text-gray-700 space-y-4">
        <p className="text-sm text-gray-500">Last updated: {new Date().toLocaleDateString()}</p>

        <h2 className="text-xl font-bold mt-6 mb-2">1. Introduction</h2>
        <p>
          Welcome to PocketHints Helper. We respect your privacy and are committed to protecting your personal data. 
          This privacy policy will inform you as to how we look after your personal data when you visit our website 
          and tell you about your privacy rights and how the law protects you.
        </p>

        <h2 className="text-xl font-bold mt-6 mb-2">2. Information We Collect</h2>
        <p>
          We may collect, use, store and transfer different kinds of personal data about you which we have grouped together follows:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Usage Data:</strong> Includes information about how you use our website, products and services.</li>
          <li><strong>Technical Data:</strong> Includes internet protocol (IP) address, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform and other technology on the devices you use to access this website.</li>
        </ul>

        <h2 className="text-xl font-bold mt-6 mb-2">3. How We Use Your Data</h2>
        <p>
          We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>To provide and maintain our service.</li>
          <li>To improve our website and content.</li>
          <li>To monitor the usage of our service.</li>
        </ul>

        <h2 className="text-xl font-bold mt-6 mb-2">4. Cookies and Analytics</h2>
        <p>
          We use cookies and similar tracking technologies to track the activity on our service and hold certain information. 
          We use Vercel Analytics to understand how our website is used.
        </p>

        <h2 className="text-xl font-bold mt-6 mb-2">5. Third-Party Links</h2>
        <p>
          This website may include links to third-party websites, plug-ins and applications. Clicking on those links or enabling those connections may allow third parties to collect or share data about you. 
          We do not control these third-party websites and are not responsible for their privacy statements.
        </p>

        <h2 className="text-xl font-bold mt-6 mb-2">6. Contact Us</h2>
        <p>
          If you have any questions about this privacy policy or our privacy practices, please contact us.
        </p>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;

